<template>
    <div>
        <!-- Confirmation / Print Button -->
        <b-container v-if="this.$store.state.requestSubmitted" fluid class="confirmation-print" style="border-color: green;">
            <b-row class="text-left">
                <b-col cols="auto">
                    <span style="font-size: 20px; font-weight: bold; color: green;">Thank you, your request has been submitted.</span>
                    <br/>
                    <span style="font-size: 14px;">Please check your email for a submission confirmation.</span>
                    <br/><br/>
                    <span style="font-size: 16px;">Your Reference Number: {{ this.newRequest.id }}</span>
                    <br/>
                </b-col>
                <b-col cols="auto">
                    <b-button type="submit" @click="printForm" variant="primary">Print</b-button>    
                </b-col>
            </b-row>
        </b-container>
        <b-container v-else fluid class="confirmation-print"  style="border-color: red;">
            <b-row class="text-left">
                <b-col cols="auto">
                        <span style="font-size: 20px; font-weight: bold; color: red;">Your request was NOT submitted.</span>
                        <br/>
                        <span style="font-size: 14px;">There was a problem submitting your request.</span>
                        <br/>
                        <span style="font-size: 14px;">You can try again later or print your request and email it to MHHPContractingRFP@memorialhermann.org.</span>
                        <br/>
                </b-col>
                <b-col cols="auto">
                    <b-button type="submit" @click="printForm" variant="primary">Print</b-button>    
                </b-col>
            </b-row>            
        </b-container>

        <br/>
        <hr class="sectionBorder">
        <h6 class="sectionCaption">CONTACT INFORMATION</h6>
        <b-container fluid>
            <!-- Contact Information -->
            <b-row>
                <b-col cols="5">
                    <span class="normal-caption">Name</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.contactName != "" ? this.newRequest.contactName : "&zwnj;" }}
                    </div>
                </b-col>                
                <b-col cols="7">
                    <span class="normal-caption">Email</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.contactEmail != "" ? this.newRequest.contactEmail : "&zwnj;" }}
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12"><br/></b-col>
            </b-row>

            <b-row>
                <b-col cols="3">
                    <span class="normal-caption">Phone</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.contactPhone != "" ? this.newRequest.contactPhone : "&zwnj;" }}
                    </div>
                </b-col>

                <b-col cols="3">
                    <span class="normal-caption">Fax</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.contactFax != "" ? this.newRequest.contactFax : "&zwnj;" }}
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12"><br/></b-col>
            </b-row>
        </b-container>

        <hr class="sectionBorder">
        <h6 class="sectionCaption">PRACTICE INFORMATION</h6>
        <b-container fluid>
            <!-- Provider Types -->
            <b-row>
                <b-col cols="12">
                    <div>
                        <div class="grp-caption">Provider Type:&nbsp;<span class="normal-text">{{ getSelectedProviderType().Description }}</span></div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12"><br/></b-col>
            </b-row>

            <!-- Practice Types -->
            <div v-if="showPracticeTypes">
                <b-row>
                    <b-col cols="12">
                        <div>
                            <div class="grp-caption">Practice Type:&nbsp;<span class="normal-text">{{ getSelectedPracticeType().Description }}</span></div>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="otherPracticeTypeChecked">
                    <b-col cols="12">
                        <div class="textbox-print">
                            {{ this.newRequest.otherPracticeTypeDescription }}
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12"><br/></b-col>
                </b-row>                
                <b-row>
                    <b-col cols="12">
                        <span class="normal-caption">Is the practitioner joining a group that is currently contracted with Memorial Hermann Health Plan?</span>
                        <span style="padding-left: 5px; padding-right: 20px;">{{ this.newRequest.associatedWithCurrentlyContractedEntity != null ? this.newRequest.associatedWithCurrentlyContractedEntity === 'Y' ? 'Yes' : 'No' : '' }}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12"><br/></b-col>
                </b-row>
            </div>

            <!-- Facility Types -->
            <div v-if="showFacilityTypes">
                <b-row>
                    <b-col cols="12">
                        <div>
                            <div class="grp-caption">Facility Type:&nbsp;<span class="normal-text">{{ getSelectedFacilityType().Description }}</span></div>
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="otherFacilityTypeChecked">
                    <b-col cols="12">
                        <div class="textbox-print">
                            {{ this.newRequest.otherFacilityTypeDescription }}
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12"><br/></b-col>
                </b-row>                
                <b-row>
                    <b-col cols="12">
                        <span class="normal-caption">Is this a new location for a company that is currently contracted with Memorial Hermann Health Plan?</span>
                        <span style="padding-left: 5px; padding-right: 20px;">{{ this.newRequest.associatedWithCurrentlyContractedEntity != null ? this.newRequest.associatedWithCurrentlyContractedEntity === 'Y' ? 'Yes' : 'No' : '' }}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12"><br/></b-col>
                </b-row>
            </div>

            <!-- Service Areas -->
            <b-row v-if="showServiceAreasinput">
                <b-col cols="12">
                    <span class="normal-caption">Service Areas (For Home Health; mobile providers and mail-order DME providers ONLY):</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.serviceAreas  != "" ? this.newRequest.serviceAreas : "&zwnj;" }}
                    </div>
                </b-col>
            </b-row>

        </b-container>

        <hr class="sectionBorder">
        <h6 class="sectionCaption">DEMOGRAPHIC INFORMATION</h6>
        <b-container fluid>
            <!-- Practitioner Name / Tax ID / NPI  / CAQH-->
            <b-row>
                <b-col v-if="showPracticeTypes" cols="6">
                    <span class="normal-caption">Practitioner Name</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.practitionerName != "" ? this.newRequest.practitionerName : "&zwnj;" }}
                    </div>
                </b-col>

                <b-col cols="2">
                    <span class="normal-caption">Tax ID #</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.taxId != "" ? this.newRequest.taxId : "&zwnj;" }}
                    </div>
                </b-col>

                <b-col cols="2">
                    <span class="normal-caption">NPI</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.npi != "" ? this.newRequest.npi : "&zwnj;" }}
                    </div>                    
                </b-col>

                <b-col cols="2">
                    <span class="normal-caption">CAQH</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.caqh != "" ? this.newRequest.caqh : "&zwnj;" }}
                    </div>                    
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12"><br/></b-col>
            </b-row>

            <!-- Business Phone / Extension / Business Fax / Business Email -->
            <b-row>
				<b-col cols="3">
                    <span class="normal-caption">Business Phone</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.businessPhone != "" ? this.newRequest.businessPhone : "&zwnj;" }}
                    </div>
                </b-col>

				<b-col cols="2">
                    <span class="normal-caption">Extension</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.businessPhoneExtension != "" ? this.newRequest.businessPhoneExtension : "&zwnj;" }}
                    </div>
                </b-col>

				<b-col cols="3">
                    <span class="normal-caption">Business Fax</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.businessFax != "" ? this.newRequest.businessFax : "&zwnj;" }}
                    </div>
                </b-col>

				<b-col cols="4">
                    <span class="normal-caption">Business Email</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.businessEmail != "" ? this.newRequest.businessEmail : "&zwnj;" }}
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12"><br/></b-col>
            </b-row>

            <!-- Specialties -->
            <b-row v-show="showSpecialties">
                <b-col cols="6">
                    <span class="normal-caption">Primary Specialty</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.getPrimarySpecialty() != undefined ? this.getPrimarySpecialty().Description : "&zwnj;" }}
                    </div>
                </b-col>
                <b-col cols="6">
                    <span class="normal-caption">Secondary Specialty</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.getSecondarySpecialty() != undefined ? this.getSecondarySpecialty().Description : "&zwnj;" }}                        
                    </div>
                </b-col>
            </b-row>
            <b-row v-show="showSpecialties">
                <b-col cols="12">
                    <br/>
                </b-col>
            </b-row>

            <!-- Business Name -->
            <b-row>
                <b-col cols="6">
                    <span class="normal-caption">Business Name</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.businessName != "" ? this.newRequest.businessName : "&zwnj;" }}
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12"><br/></b-col>
            </b-row>            

            <!-- Primary Address -->
            <b-row>
                <b-col cols="9">
                    <span class="normal-caption">Address</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.primaryAddress.addressLine1 != "" ? this.newRequest.primaryAddress.addressLine1 : "&zwnj;" }}
                    </div>
                </b-col>

                <b-col cols="3">
                    <span class="normal-caption">Suite</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.primaryAddress.suite != "" ? this.newRequest.primaryAddress.suite : "&zwnj;" }}
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12"><br/></b-col>
            </b-row>            

            <b-row>
                <b-col cols="5">
                    <span class="normal-caption">City</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.primaryAddress.city != "" ? this.newRequest.primaryAddress.city : "&zwnj;" }}
                    </div>                    
                </b-col>

                <b-col cols="2">
                    <span class="normal-caption">State</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.primaryAddress.state != "" ? this.newRequest.primaryAddress.state : "&zwnj;" }}
                    </div>                    
                </b-col>

                <b-col cols="4">
                    <span class="normal-caption">Zip Code</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.primaryAddress.zipcode != "" ? this.newRequest.primaryAddress.zipcode : "&zwnj;" }}
                    </div>                    
                </b-col>                
            </b-row>
            <b-row>
                <b-col cols="12">
                    <br/>
                </b-col>
            </b-row>                        

            <!-- Address Grid -->
            <b-row>
                <b-col cols="12">
                    <br/>
                    <span class="normal-caption">Additional Addresses:</span>
                    <br/>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col cols="12">
                    <b-table
                    responsive
                    outlined
                    id="addresses"
                    :items="this.newRequest.addresses"
                    :fields="this.addressesFields">
                    </b-table>
                </b-col>
            </b-row>            
        </b-container>


        <hr class="sectionBorder">
        <h6 class="sectionCaption">SERVICE INFORMATION</h6>
        <b-container fluid>

            <!-- Population Types -->
            <b-row>
                <b-col cols="12">
                    <div>
                        <div class="grp-caption">Ages Served</div>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col v-if="this.newRequest.servesAges_0_2" cols="2">0-2 Years</b-col>
                <b-col v-if="this.newRequest.servesAges_2_18" cols="2">2-18 Years</b-col>
                <b-col v-if="this.newRequest.servesAges_18_Plus" cols="2">18+ Years</b-col>
                <b-col v-if="this.newRequest.servesAges_Geriatric" cols="2">Geriatrics</b-col>
            </b-row>
            <b-row v-if="otherPopulationTypeChecked">
                <b-col cols="12">
                    <br/>
                    Other Ages Served:
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.otherPopulationTypeDescription }}
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <!-- Languages -->
                <b-col cols="6" style="padding-left: 0px; padding-right: 0px;">
                    <b-container fluid>
                        <b-row>
                            <b-col>
                                <br/>
                                <span class="normal-caption">Languages Spoken (other than English)</span>
                                <br/>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="" style="margin-top: 5px; border: 1px solid rgb(206, 212, 218); border-radius: 0.25rem; padding: 3px;">
                                    <span v-for="language in getSelectedLanguages()" :key="language.Id">{{ language.Description }} <br/></span>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row v-if="otherLanguageChecked">
                            <b-col>
                                <br/>
                                Other Languages Spoken
                                <br/>
                                <div class="textbox-print">
                                    {{ this.newRequest.otherLanguageDescription }}
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>

                <!-- Office Hours -->
                <b-col cols="6" style="padding-left: 0px; padding-right: 0px;">
                    <b-container fluid>
                        <b-row>
                            <b-col>
                                <br/>
                                <span class="normal-caption">Office Hours</span>
                                <br/>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-container fluid style="margin-top: 5px; border: 1px solid rgb(206, 212, 218); border-radius: 0.25rem; padding: 5px; overflow-x: hidden !important; overflow-y: hidden;">
                                    <b-row>
                                        <b-col cols="2" class="weekdayCaption">
                                            Monday:
                                        </b-col>
                                        <b-col cols="10" class="weekdayTextContainer">
                                            <div class="textbox-print">
                                                {{ this.newRequest.officeHoursMonday != "" ? this.newRequest.officeHoursMonday : "&zwnj;" }}
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="2" class="weekdayCaption">
                                            <span class="normal-text" style="text-align: right !important;">Tuesday:</span>
                                        </b-col>
                                        <b-col cols="10" class="weekdayTextContainer">
                                            <div class="textbox-print">
                                                {{ this.newRequest.officeHoursTuesday != "" ? this.newRequest.officeHoursTuesday : "&zwnj;" }}
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="2" class="weekdayCaption">
                                            <span class="normal-text" style="text-align: right !important;">Wednesday:</span>
                                        </b-col>
                                        <b-col cols="10" class="weekdayTextContainer">
                                            <div class="textbox-print">
                                                {{ this.newRequest.officeHoursWednesday != "" ? this.newRequest.officeHoursWednesday : "&zwnj;" }}
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="2" class="weekdayCaption">
                                            <span class="normal-text" style="text-align: right !important;">Thursday:</span>
                                        </b-col>
                                        <b-col cols="10" class="weekdayTextContainer">
                                            <div class="textbox-print">
                                                {{ this.newRequest.officeHoursThursday != "" ? this.newRequest.officeHoursThursday : "&zwnj;" }}
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="2" class="weekdayCaption">
                                            <span class="normal-text" style="text-align: right !important;">Friday:</span>
                                        </b-col>
                                        <b-col cols="10" class="weekdayTextContainer">
                                            <div class="textbox-print">
                                                {{ this.newRequest.officeHoursFriday != "" ? this.newRequest.officeHoursFriday : "&zwnj;" }}
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="2" class="weekdayCaption">
                                            <span class="normal-text" style="text-align: right !important;">Saturday:</span>
                                        </b-col>
                                        <b-col cols="10" class="weekdayTextContainer">
                                            <div class="textbox-print">
                                                {{ this.newRequest.officeHoursSaturday != "" ? this.newRequest.officeHoursSaturday : "&zwnj;" }}
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="2" class="weekdayCaption">
                                            <span class="normal-text" style="text-align: right !important;">Sunday:</span>
                                        </b-col>
                                        <b-col cols="10" class="weekdayTextContainer">
                                            <div class="textbox-print">
                                                {{ this.newRequest.officeHoursSunday != "" ? this.newRequest.officeHoursSunday : "&zwnj;" }}
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-container>                                
                            </b-col>
                        </b-row>
                    </b-container>                    
                </b-col>
            </b-row>           
        </b-container>


        <hr class="sectionBorder">
        <h6 class="sectionCaption">NETWORK AFFILIATIONS</h6>
        <b-container fluid>
            <!-- MHMD Affiliation / Ohter IPA/PHO Affiliations -->            
            <!-- MHMD Applied -->
            <b-row>
                <b-col cols="12">
                    <span class="normal-caption">Have you ever applied to MHMD?</span>
                    <span style="padding-left: 5px; padding-right: 20px;">{{ this.newRequest.mhmdApplied != null ? this.newRequest.mhmdApplied === 'Y' ? 'Yes' : 'No' : '' }}</span>
                    <span v-if="mhmdAppliedYes" class="normal-caption">Application Status:</span>
                    <span v-if="mhmdAppliedYes" style="padding-left: 5px; padding-right: 20px;">{{ this.getMHMDApplicationStatus() != undefined ? this.getMHMDApplicationStatus().Description : "&zwnj;" }}</span>
                    <span v-if="mhmdAppliedYes && this.newRequest.mhmdApplicationStatus === 7" class="normal-caption">Terminated Date:</span>
                    <span v-if="mhmdAppliedYes && this.newRequest.mhmdApplicationStatus === 7" style="padding-left: 5px;">{{ this.newRequest.mhmdTerminatedDate }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12"><br/></b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <span class="normal-caption">Other Network/IPA/PHO Affliations</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.otherIPAPHOAffiliations != "" ? this.newRequest.otherIPAPHOAffiliations : "&zwnj;" }}
                    </div>
                </b-col>            
            </b-row>
            <b-row>
                <b-col cols="12"><br/></b-col>
            </b-row>
        </b-container>


        <hr class="sectionBorder">
        <h6 class="sectionCaption">CREDENTIALING CONTACT INFORMATION</h6>
        <b-container fluid>
            <!-- Credintialing Contact / Email / Phone -->
            <b-row>
                <b-col cols="4">
                    <span class="normal-caption">Credentialing Contact:</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.credentialingContactName != "" ? this.newRequest.credentialingContactName : "&zwnj;" }}
                    </div>
                </b-col>

                <b-col cols="4">
                    <span class="normal-caption">Credentialing Contact E-mail Address:</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.credentialingContactEmail != "" ? this.newRequest.credentialingContactEmail : "&zwnj;" }}
                    </div>
                </b-col>

                <b-col cols="4">
                    <span class="normal-caption">Credentialing Contact Phone #:</span>
                    <br/>
                    <div class="textbox-print">
                        {{ this.newRequest.credentialingContactPhone != "" ? this.newRequest.credentialingContactPhone : "&zwnj;" }}
                    </div>                    
                </b-col>
            </b-row>            
        </b-container>

    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
created() {
    },    
    data() {
        return {
        addressesFields: [
            { key: 'addressLine1', label: 'Address' },
            { key: 'suite', label: 'Suite' },
            { key: 'city', label: 'City' },
            { key: 'state', label: 'State' },
            { key: 'zipcode', label: 'Zip', formatter: 'zipCodeFormatter'},
            ],           
        } 
    },

    computed: {
        ...mapState(
            'request', {
                optionsProviderTypes: 'providerTypes',                
                optionsPracticeTypes: 'practiceTypes',
                otherPracticeType: 'otherPracticeType',
                optionsFacilityTypes: 'facilityTypes',
                otherFacilityType: 'otherFacilityType',
                optionsSpecialties: 'specialties',
                optionsLanguages: 'languages',
                otherLanguage: 'otherLanguage',
                optionsMHMDApplicationStatuses: 'MHMDApplicationStatuses',
                newRequest: 'newRequest',
                newAddress: 'newAddress'
                }
        ),

        showPracticeTypes() {
            return this.newRequest.selectedProviderType === 1;
        },        
        otherPracticeTypeChecked() {
            return this.newRequest.selectedPracticeType === 999;
        },

        showFacilityTypes() {
            return this.newRequest.selectedProviderType === 2;
        },
        otherFacilityTypeChecked() {
            return this.newRequest.selectedFacilityType === 999;
        },
        showServiceAreasinput() {
            return this.showFacilityTypes
                && this.optionsFacilityTypes
                    .filter(ft => ft.EnableAdditionalDetails === true)
                        .map(function(a) {return a.Id})
                            .includes(this.newRequest.selectedFacilityType);
        },

        showSpecialties() {
            return this.newRequest.selectedProviderType === 1;
        },

        mhmdAppliedYes() {
            return this.newRequest.mhmdApplied === 'Y';
        },

        otherPopulationTypeChecked() {
            return this.newRequest.servesAges_Other === true;
        },

        otherLanguageChecked() {
            return this.newRequest.selectedLanguages.includes(999);
        },        
    },

    mounted () {
        this.$nextTick(function (){
            // setTimeout(function() {
            //     window.print();
            //     }, 1500);
        })
    },

    methods: {
        ...mapActions(
            'request', {
                loadProviderTypes: 'loadProviderTypes',                
                loadPracticeTypes: 'loadPracticeTypes',
                loadFacilityTypes: 'loadFacilityTypes',
                loadSpecialties: 'loadSpecialties',
                loadLanguages: 'loadLanguages',
                loadMHMDApplicationStatuses: 'loadMHMDApplicationStatuses',
                addRequest: 'addRequest',
                }
        ),

        getSelectedProviderType() {
            return this.optionsProviderTypes
                .find(x => x.Id === this.newRequest.selectedProviderType);
        },

        getSelectedPracticeType() {
            return this.newRequest.selectedPracticeType === 999 ?
                this.otherPracticeType
                : this.optionsPracticeTypes.find(x => x.Id === this.newRequest.selectedPracticeType);
        },

        getSelectedFacilityType() {
            return this.newRequest.selectedFacilityType === 999 ?
                this.otherFacilityType
                : this.optionsFacilityTypes.find(x => x.Id === this.newRequest.selectedFacilityType);            
        },

        getPrimarySpecialty() {
            return this.optionsSpecialties.find(x => x.Id === this.newRequest.primarySpecialty);
        },
        getSecondarySpecialty() {
            return this.optionsSpecialties.find(x => x.Id === this.newRequest.secondarySpecialty);
        },
        
        getMHMDApplicationStatus() {
            return this.optionsMHMDApplicationStatuses.find(x => x.Id === this.newRequest.mhmdApplicationStatus);
        },

        getSelectedLanguages() {
            return this.optionsLanguages
            .filter(x => this.newRequest.selectedLanguages
                .indexOf(x.Id) >= 0)
                    .sort(function (a, b) {return a.Description - b.Description});
        },

        zipCodeFormatter(value) {
            var result = "";
            if(value.length == 5)
            {
                result = value.substring(0, 5);
            } else if (value.length == 9) { 
                result = value.substring(0, 5) + '-' + value.substring(5, 9);
            }
             
            return `${result}`;
        },

        booleanToYNFormatter(value) {
            return `${(value == null ? "" : value == "true" ? "Yes" : "No")}`;
        },
        
        printForm(evt) {
            evt.preventDefault();
            window.print();
        },        
    },
}
</script>

<style>
.grp-caption {
    font-size: large;
    font-weight: bolder;
    padding-bottom: 5px;
    display:flexbox;
}
.normal-caption {
    font-weight: bolder;
    padding-bottom: 5px;
    display:flexbox;    
}
.normal-text {
    font-weight:normal;
    padding-bottom: 5px;
    display:flexbox;    
}
.textbox-print {
    margin-top: 5px;
    border: 1px solid rgb(206, 212, 218);
    border-radius: 0.25rem;
    padding: 3px;
    /* min-height: 20px; */
    overflow-wrap: break-word;
}
.weekdayCaption {
    padding-top: 18px;
    padding-right: 0px !important;
    text-align: right !important;
}
.weekdayTextContainer {
    padding-top: 12px;
    padding-left: 20px !important;
}
.confirmation-print {
    margin-top: 5px;
    border: 1px solid;
    border-radius: 0.25rem;
    padding: 7px;
}
/* @media print {
  .confirmation-print {
    display: none;
  }
} */
hr.sectionBorder {
  border: 1px dashed black;
}
h6.sectionCaption {
  font-weight: bold;
  text-align: center;
}
</style>